module.exports = __webpack_public_path__ + "static/media/bg-icon-01.152845ad.png";